import { Component, OnInit, ViewChild } from '@angular/core';
import { trigger, state, transition, style, animate } from '@angular/animations';
import { Client } from '../../models/client.model';
import { EventRoadService } from '../../services/eventRoad.service';
import { MatTableDataSource, MatPaginator, MatSort, MatDialog } from '@angular/material';
import { ShowerrordialogComponent } from '../showerrordialog/showerrordialog.component';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { ClientService } from '../../services/client.service';
import { Roadbook } from 'src/app/models/roadbook.model';
import { Observable } from 'rxjs';
import { RoadbookSelectorComponent } from '../roadbook-selector/roadbook-selector.component';
import { NotificationVN } from '../../models/notification.model';
import { NotificationService } from '../../services/notification.service';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-notifications-page',
  templateUrl: './notifications-page.component.html',
  styleUrls: ['./notifications-page.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class NotificationsPageComponent implements OnInit {
  panelOpenState = false;
  newnotificationform: FormGroup;
  notifications: NotificationVN[] = [];
  expandedElement: NotificationVN | null;
  displayedColumns: string[] = ['star', 'title', 'message', 'date', 'state', 'visible' ];
  dataSource: MatTableDataSource<NotificationVN>;
  filteredNotifications: Observable<any>;
//   roadbooks: Roadbook[];
  editingNotification: NotificationVN = null;
//   currentRoadbooksIds = [];
  roadbooksDict = {};
  devMode = false;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  constructor(private formBuilder: FormBuilder,
    private roadbookProvider: EventRoadService,
    private notificationProvider: NotificationService,
    public dialog: MatDialog) {
    this.newnotificationform = this.formBuilder.group({
      title: [null, Validators.required],
      message: [null, null],
      url: [null, null]
    });
    this.devMode = !environment.production;
   }

  ngOnInit(): void {
    // this.roadbookProvider.getAll().subscribe(data => {
    //   this.roadbooks = data;
    //   this.roadbooksDict = {};
    //   data.forEach(di => this.roadbooksDict[di.id] = di);
      this.notificationProvider.getAll().subscribe(nots => {
        this.notifications =  nots;
        this.dataSource = new MatTableDataSource(this.notifications);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      });
    // });
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  saveNotification() {
    const errors = this.ValidateForm();
    if (errors.length === 0) {
          const noti = this.getNotificationFromForm();
        if (this.editingNotification) {
            noti.i = this.editingNotification.i;
            noti.v = this.editingNotification.v;
            this.notificationProvider.edit(noti);
            this.editingNotification = null;
          } else {
              let message = `You are creating a new notification that it will be sended to all diveces.
              The info of the notification is: <br/><br/><ul><li><b>Title: </b>${noti.t}</li><li><b>Message: </b>${noti.m}</li>`;
                if (noti.u) {
                    message += `<li><b>Url: </b>${noti.u}</li>`;
                }
              message += '</ul>';
            const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
                width: '60%',
                data: {
                    title: 'New notification',
                    message
                }
              });
              dialogRef.afterClosed().subscribe(create => {
                if (create) {
                    const result = this.notificationProvider.create(noti);
                }
              });
          }
          this.reset();
    } else {
      const dialogRef = this.dialog.open(ShowerrordialogComponent, { data: errors });
    }
  }

  editElemet(element) {
    this.editingNotification = element;
    this.newnotificationform.controls['title'].setValue(this.editingNotification.t);
    this.newnotificationform.controls['message'].setValue(this.editingNotification.m);
    this.newnotificationform.controls['url'].setValue(this.editingNotification.u);
    this.panelOpenState = true;
    window.scroll(0, 0);
  }
//   removeElemet(element) {
//     this.clientProvider.remove(element);
//   }
  getNotificationFromForm() {
    // const visible = this.newclientform.controls['visible'].value;
    // const roadbooks = this.currentRoadbooksIds;
    return new NotificationVN('',
      this.newnotificationform.controls['title'].value,
      this.newnotificationform.controls['message'].value,
      this.newnotificationform.controls['url'].value,
      new Date());
  }
  changeCheckBox(row, event) {
    this.notificationProvider.editVisible(row, event.checked);
  }

  ValidateForm() {
    const errors = [];
    if (!this.newnotificationform.controls['title'].value) { errors.push('Cal indicar el títol de la notificació'); }
    if (!this.newnotificationform.controls['message'].value) { errors.push(`Cal indicar el missatge de la notificació`); }
    return errors;
  }
  reset() {
    // this.currentRoadbooksIds = [];
    this.newnotificationform.reset();
  }
//   openDialog(): void {
//     const dialogRef = this.dialog.open(RoadbookSelectorComponent, {
//       width: '60%',
//       data: { roadbooks_ids: this.currentRoadbooksIds }
//     });

//     dialogRef.afterClosed().subscribe(result => {
//       if (result) {
//         this.currentRoadbooksIds = result;
//         if (this.editingClient) {
//           this.editingClient.r = result;
//         }
//       }
//     });
//   }
}
